import API from "../../../utils/helpers/API.helpers";

const BerkasSidangService = {
  async getBerkasSidangByMkSpesialId(mkSpesialID) {
    return await API.get({
      endpoint: `/mahasiswa/get-berkas-sidang?mk_spesial=${mkSpesialID}`,
    });
  },
  async uploadBerkasSidang(data) {
    return await API.post({ endpoint: "/submisi/berkas-sidang/", data: data });
  },
  async getBerkasFinalByMkSpesialId(mkSpesialID) {
    return await API.get({
      endpoint: `/mahasiswa/get-berkas-final?mk_spesial=${mkSpesialID}`,
    });
  },
  async uploadBerkasFinal(berkasFinalData) {
    return await API.post({
      endpoint: "/submisi/berkas-akhir/",
      data: berkasFinalData,
    });
  },
};

export { BerkasSidangService };
